module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ordersubmit"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-my-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 center"
  }, [_c('p', {
    staticClass: "contract-header"
  }, [_vm._v("Congratulations")]), _vm._v(" "), _c('p', [_vm._v("Your frame collection order has successfully been placed!")]), _vm._v(" "), _c('p', [_vm._v("Your collection will arrive in 2 to 4 weeks.")]), _vm._v(" "), _c('p', [_vm._v("Your will receipt will be emailed to you.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Home')
      }
    }
  }, [_vm._v("Return Home")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Order')
      }
    }
  }, [_vm._v("Place New Order")])])])])])]), _vm._v(" "), (_vm.isBillingShown) ? _c('frame-shipping-billing', {
    on: {
      "close": function($event) {
        return _vm.ToggleBilling()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5761d19a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5761d19a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/frameResources/FrameOrderSuccess.vue
// module id = 525
// module chunks = 4